import accountSales from './accountSales.json';
import discount from './discount.json';
import settingsEmployees from './settingsEmployees.json';
import addressForm from './addressForm.json';
import discountPopup from './discountPopup.json';
import payment from './payment.json';
import advancedCustomerSearch from './advancedCustomerSearch.json';
import editEmployee from './editEmployee.json';
import printCoupons from './printCoupons.json';
import settingsLanguage from './settingsLanguage.json';
import employee from './employee.json';
import productGroupEditTexts from './productGroupEditTexts.json';
import settingsNoteButtons from './settingsNoteButtons.json';
import billTable from './billTable.json';
import employeeStats from './employeeStats.json';
import productGroup from './productGroup.json';
import settingsOnScreenKeyboard from './settingsOnScreenKeyboard.json';
import fiscalIntegration from './fiscalIntegration.json';
import product from './product.json';
import campaigns from './campaigns.json';
import giftcard from './giftcard.json';
import productSearch from './productSearch.json';
import cashInOut from './cashInOut.json';
import changePassword from './changePassword.json';
import header from './header.json';
import returnTranslation from './return.json';
import changePin from './changePin.json';
import sale from './sale.json';
import settingsTaxRates from './settingsTaxRates.json';
import clockInOut from './clockInOut.json';
import layaway from './layaway.json';
import saleNotes from './saleNotes.json';
import settingsUserInterface from './settingsUserInterface.json';
import common from './common.json';
import limitPerSale from './limitPerSale.json';
import scannerSelection from './scannerSelection.json';
import shipping from './shipping.json';
import contacts from './contacts.json';
import localDBs from './localDBs.json';
import scanSearchResults from './scanSearchResults.json';
import createCustomer from './createCustomer.json';
import login from './login.json';
import search from './search.json';
import shortcuts from './shortcuts.json';
import createNew from './createNew.json';
import managerOverride from './managerOverride.json';
import customerButtons from './customerButtons.json';
import stockTransfer from './stockTransfer.json';
import customerDisplay from './customerDisplay.json';
import settingsAgeVerification from './settingsAgeVerification.json';
import switchUser from './switchUser.json';
import customerInformation from './customerInformation.json';
import settingsAssociatePos from './settingsAssociatePos.json';
import taxExempt from './taxExempt.json';
import customer from './customer.json';
import offer from './offer.json';
import settingsCompany from './settingsCompany.json';
import unpaidInvoice from './unpaidInvoice.json';
import customerNotes from './customerNotes.json';
import offlineLogin from './offlineLogin.json';
import customerSearch from './customerSearch.json';
import openCloseDay from './openCloseDay.json';
import customPrompts from './customPrompts.json';
import zReport from './zReport.json';
import order from './order.json';
import payCheckForm from './payCheckForm.json';
import settingsCustomPayment from './settingsCustomPayment.json';

export const tr = {
  accountSales,
  discount,
  settingsEmployees,
  addressForm,
  discountPopup,
  payment,
  advancedCustomerSearch,
  editEmployee,
  printCoupons,
  settingsLanguage,
  employee,
  productGroupEditTexts,
  settingsNoteButtons,
  billTable,
  employeeStats,
  productGroup,
  settingsOnScreenKeyboard,
  fiscalIntegration,
  product,
  campaigns,
  giftcard,
  productSearch,
  cashInOut,
  changePassword,
  header,
  return: returnTranslation,
  changePin,
  sale,
  settingsTaxRates,
  clockInOut,
  layaway,
  saleNotes,
  settingsUserInterface,
  common,
  limitPerSale,
  scannerSelection,
  shipping,
  contacts,
  localDBs,
  scanSearchResults,
  createCustomer,
  login,
  search,
  shortcuts,
  createNew,
  managerOverride,
  customerButtons,
  stockTransfer,
  customerDisplay,
  settingsAgeVerification,
  switchUser,
  customerInformation,
  settingsAssociatePos,
  taxExempt,
  customer,
  offer,
  settingsCompany,
  unpaidInvoice,
  customerNotes,
  offlineLogin,
  customerSearch,
  openCloseDay,
  customPrompts,
  zReport,
  order,
  payCheckForm,
  settingsCustomPayment,
};
